import { SupabaseClient } from '@supabase/supabase-js';

// Verificar e renovar token periodicamente em background
export const setupAuthRefresh = (supabase: SupabaseClient) => {
  if (typeof window === 'undefined') return;

  console.log('[Auth] Configurando refresh automático de token...');

  // Verificar a cada 30 minutos se o token precisa ser renovado
  const intervalId = setInterval(async () => {
    try {
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('[Auth] Erro ao verificar sessão:', error);
        return;
      }

      if (!session) {
        console.log('[Auth] Nenhuma sessão ativa para renovar');
        return;
      }

      // Se o token expira em menos de 10 minutos, renovar
      const expiresAt = session.expires_at || 0;
      const now = Math.floor(Date.now() / 1000);
      const timeUntilExpiry = expiresAt - now;

      if (timeUntilExpiry < 600) { // 10 minutos
        console.log('[Auth] Token próximo de expirar, renovando...');
        const { error: refreshError } = await supabase.auth.refreshSession();
        
        if (refreshError) {
          console.error('[Auth] Erro ao renovar sessão:', refreshError);
        } else {
          console.log('[Auth] ✅ Token renovado com sucesso');
        }
      } else {
        const minutesUntilExpiry = Math.floor(timeUntilExpiry / 60);
        console.log(`[Auth] Token válido por mais ${minutesUntilExpiry} minutos`);
      }
    } catch (error) {
      console.error('[Auth] Erro no refresh automático:', error);
    }
  }, 30 * 60 * 1000); // 30 minutos

  // Limpar interval quando necessário
  return () => clearInterval(intervalId);
};
